import React from 'react';

import { X } from 'lucide-react';

const EbookPurchaseSuccessModal = ({ open, onClose }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/30" onClick={onClose} />
      <div className="relative w-full max-w-lg mx-4 bg-white rounded-2xl shadow-2xl border border-black/10 overflow-hidden">
        <div className="flex items-start justify-between px-6 py-5 border-b border-[#e8e6e1]">
          <div>
            <p className="text-xs tracking-widest uppercase text-[#243B29]/80">Thank you</p>
            <h3 className="text-lg font-semibold text-[#1e1919]">You’re all set.</h3>
          </div>
          <button
            onClick={onClose}
            className="p-2 rounded-full hover:bg-black/5 transition-colors"
            aria-label="Close"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="px-6 py-5">
          <p className="text-sm text-[#736c64] leading-relaxed">
            Your download link will arrive by email from <strong>hello@myhearthlowe.com</strong>.
          </p>
          <p className="text-sm text-[#736c64] leading-relaxed mt-3">
            If you don’t see it within 10 minutes, please check spam/promotions.
          </p>
          <p className="text-sm text-[#736c64] leading-relaxed mt-3">
            Still nothing? Email us at <strong>hello@myhearthlowe.com</strong> and we’ll help right away.
          </p>
        </div>

        <div className="px-6 py-4 bg-[#f7f5f2] border-t border-[#e8e6e1] flex items-center justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg bg-[#a8b5a0] hover:bg-[#8fa087] text-white text-sm font-medium transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default EbookPurchaseSuccessModal;
